import { render } from "./scenario-select-image.vue?vue&type=template&id=3bd648d0&ts=true"
import script from "./scenario-select-image.vue?vue&type=script&lang=ts"
export * from "./scenario-select-image.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__